exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p{margin-bottom:12px}ol{list-style:inside}.articleLoader{position:relative;width:100%;height:100%}.articleLoader-button{left:50%;transform:translateX(-50%);width:300px!important;height:84px!important;margin-bottom:112px}@media (max-width:440px){.articleLoader-button{margin-bottom:72px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77d287f5","scoped":false,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/combinedBlocks/ArticleLoader.vue
// module id = 465
// module chunks = 0